import { createEventEmitter } from '@altirllc/shared/utils/createEventEmitter';
import type { TAction } from '@altirllc/shared/utils/types/common';
import type { TGetTokenResponse } from '@altirllc/shared/utils/types/profile';

import { LOAD_SMARTLOOK_SCRIPTS } from '@/constants';

import { clearPersistentFilters } from '@/components/filter/usePersistentFilter';

import { queryClient } from '@/queryClient';
import { resetSmartlookIdentity } from '@/scripts/smartlook';
import { storage } from '@/storage';
import { tokenUtils } from '@/tokenUtils';
import { resetTrackerUser } from '@/tracking/initTracking';

const eventEmitter = createEventEmitter();

export const login = (tokens: TGetTokenResponse) => {
  tokenUtils.setTokens(tokens);
  eventEmitter.raise();
};

/**
 * Signs the partner out: clears saved filters, tokens, the tracker identity and the whole React
 * Query cache (`queryClient.clear()`), so the next partner who signs in on this browser never sees
 * the previous partner's data.
 * Also runs when the token refresh fails (the refresh interceptor calls `logout()`), so that path
 * clears the cache too.
 * Constraint: keep `queryClient.clear()` here, not in a React effect, so the cache is empty before
 * any other partner can sign in, even when no component is mounted.
 */
export const logout = () => {
  clearPersistentFilters(storage);
  tokenUtils.cleanTokens();
  eventEmitter.raise();

  if (LOAD_SMARTLOOK_SCRIPTS) {
    resetSmartlookIdentity();
  }

  queryClient.clear();
  resetTrackerUser();
};

export const onAuthChange = (listener: TAction) => eventEmitter.subscribe(listener);
